import { SubscriptionCard } from "../SubscriptionCard";
import { type ViewingPeriod } from "@/lib/periodStorageUtils";
import { type Subscription } from "@/types/subscription";

interface SubscriptionGridProps {
  subscriptions: Subscription[];
  currentPeriod: ViewingPeriod;
  onEdit: (subscriptionId: string) => void;
}

export const SubscriptionGrid = ({
  subscriptions,
  currentPeriod,
  onEdit,
}: SubscriptionGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      {subscriptions.map((subscription) => (
        <div key={subscription.id} className="smooth-appear">
          <SubscriptionCard
            subscription={subscription}
            onEdit={() => onEdit(subscription.id)}
            currentPeriod={currentPeriod}
          />
        </div>
      ))}
    </div>
  );
};

SubscriptionGrid.displayName = "SubscriptionGrid";
